class FreshChat {
  constructor(document) {
    this.document = document
    this.chatOpeners = this.document.querySelectorAll('.jsOpenGorgias')
    this.firstVisit = localStorage.getItem('gorgiasFirstVisit')
    this.open = this.open.bind(this)
    this.staticUnreadCount = this.staticUnreadCount.bind(this)
    this.staticUnreadCount()
    this.open()
  }

  initializePromise(i, t) {
    return new Promise((resolve, reject) => {
      var e
      i.getElementById(t)
        ? resolve()
        : (((e = i.createElement('script')).id = t),
          (e.async = true),
          (e.src = 'https://haloboard.freshchat.com/js/widget.js'),
          (e.onload = resolve),
          i.head.appendChild(e))
    })
  }

  initiateCallPromise() {
    return this.initializePromise(this.document, 'Freshchat-js-sdk')
  }

  initWidget() {
    return new Promise((resolve, reject) => {
      window.fcWidget.init({
        token: '62c58550-4944-4ecc-8840-7c5e669bd381',
        host: 'https://haloboard.freshchat.com',
        siteId: 'siteIdA',
        config: {
          headerProperty: {
            hideChatButton: true,
          },
        },
      })
      resolve()
    })
  }

  open() {
    for (const GO of this.chatOpeners) {
      GO.addEventListener('click', (e) => {
        e.preventDefault()
        this.addLoadingClass()
        this.initiateCallPromise().then(() => {
          console.log('Freshchat-js-sdk loaded')
          this.initWidget().then(() => {
            console.log('Freshchat widget loaded')
            window.fcWidget.open()
            this.loadWidgetEvents()
          })
        })
      })
    }
  }

  addLoadingClass() {
    this.document.body.classList.add('gorgias--loading')
  }

  staticUnreadCount() {
    if (this.firstVisit !== 'false') {
      document.querySelector('#chatUnreadCount').innerHTML = 1
      document.querySelector('#chatUnreadCount').style.display = 'block'
    }
  }

  loadWidgetEvents() {
    const isFirstVisit = this.isFirstVisit
    window.fcWidget.on('widget:opened', function (data) {
      document.dispatchEvent(new Event('gorgias:opened'))
      console.log('Freshchat widget opened')
      document.documentElement.classList.add('gorgias--open')
      document.body.classList.add('gorgias--open')
      document.body.classList.remove('gorgias--closed')
      document.body.classList.remove('gorgias--loading')
      if (is_touch_device()) {
        showDialog()
      }
      if (isFirstVisit !== 'false') {
        localStorage.setItem('gorgiasFirstVisit', 'false')
      }
      document.querySelector('#chatUnreadCount').style.display = 'none'
      document.querySelector('#chatUnreadCount').innerHTML = 0
    })

    window.fcWidget.on('widget:closed', function (data) {
      document.body.classList.add('gorgias--closed')
      document.body.classList.remove('gorgias--open')
      document.documentElement.classList.remove('gorgias--open')
      if (is_touch_device()) {
        closeDialog()
      }

      if (is_touch_device() && $(window).width() <= 480) {
        document.documentElement.classList.remove('is-mobile-nav-open')
        if (document.querySelector('.js-header-hamburger_title')) {
          document.querySelector('.js-header-hamburger_title').textContent =
            'menu'
        }
      }
    })

    window.fcWidget.on('unreadCount:notify', function (resp) {
      console.log(resp.count)
      if (resp.count != 0) {
        document.querySelector('#chatUnreadCount').style.display = 'block'
        document.querySelector('#chatUnreadCount').innerHTML = resp.count
      }
    })
  }
}

const freshChat = new FreshChat(document)
